import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceStackedRenderComponent } from './render/slice-stacked-render.component';


export const sliceStackedRenderModuleEntryComponents = [
  SliceStackedRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: sliceStackedRenderModuleEntryComponents
})
export class SliceStackedRenderModule {}

export default sliceStackedRenderModuleEntryComponents;
